import { keyframes } from "src/lib/styles/css";

export default keyframes`
	0% {
		transform: translateY(100%);
	}

	100% {
		transform: translateY(0);
	}
`;